import React from "react";
import ExclamationIcon from "../icons/ExclamationIcon";
import Icon from "../notification/Icon";

function MessageSentModal({ handleShowModal, success }) {
  return (
    <React.Fragment>
      <div
        onClick={handleShowModal}
        className="flex justify-center items-center fixed z-50 inset-0 outline-none focus:outline-none p-6"
      >
        {/*content*/}

        <div className="flex flex-col justify-center items-center rounded-lg shadow-lg m-10 mb-20 bg-white focus:outline-none mx-5 w-4/5 sm:w-[450px] max-h-[75vh] pb-3">
          <div className="mt-8 text-center w-full">
            {success ? (
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
                <svg
                  className="h-12 w-12 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
            ) : (
              <div className="mx-auto flex text-red-500 items-center justify-center  h-16 w-16 ">
                <svg
                  aria-hidden="true"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>exclamation icon</title>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11.9942 14.1048C12.8289 14.1048 13.5184 14.7944 13.5184 15.629C13.5184 16.5 12.8289 17.1532 11.9942 17.1532C11.1232 17.1532 10.47 16.5 10.47 15.629C10.47 14.7944 11.1232 14.1048 11.9942 14.1048ZM10.7966 12.9073L10.5426 7.97177C10.5426 7.71774 10.724 7.5 10.9781 7.5H12.974C13.2281 7.5 13.4095 7.71774 13.4095 7.97177L13.1555 12.9073C13.1555 13.125 12.9377 13.3065 12.72 13.3065H11.2321C11.0143 13.3065 10.7966 13.125 10.7966 12.9073Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            )}

            <div className="mt-2 text-xl font-medium text-gray-900">
              {success ? "Success" : "Failed"}
            </div>
            <div className="mt-1 px-7 ">
              <p className="text-sm text-gray-500">
                {success
                  ? "Your message was received. We will get back to you shortly."
                  : "Something went wrong. Try again later"}
              </p>
            </div>

            <div className=" flex flex-col items-center px-4 py-3 w-full">
              <button
                onClick={handleShowModal}
                className={`px-4 py-2 text-white text-base font-medium rounded-md w-full shadow-sm  focus:outline-none focus:ring-2 ${
                  success
                    ? "bg-green-500 hover:bg-green-600 focus:ring-green-300"
                    : "bg-red-500 hover:bg-red-600 focus:ring-red-300"
                }`}
              >
                OK
              </button>
            </div>
          </div>

          <div className="flex w-full overflow-auto  sm:rounded-lg"></div>
        </div>
      </div>
      <div className="opacity-80 fixed inset-0 z-40 bg-black"></div>
    </React.Fragment>
  );
}

export default MessageSentModal;
